// Builds the starting point for "Kopioi" on an activity: everything that describes
// WHAT the activity is carries over, everything that describes THIS occurrence of it
// does not. The result is fed into ActivityCreator as a pre-filled form; nothing is
// written until the user finishes the Stepper.

export const COPY_NAME_SUFFIX = ' (kopio)'

// Server-owned or identifying one specific instance. Never carried into a copy.
// Dropping the recurrence fields is deliberate: copying one occurrence of a series
// gives a plain one-off, not a new series.
const DROPPED_FIELDS = [
  'id',
  'creatorId',
  'created',
  'updaterId',
  'updated',
  'timestamp',
  'date',
  'participants',
  'queue',
  'payments',
  'refunds',
  // court bookings belong to the original; the copy books its own from the Varaukset tab
  'reservations',
  'recurrentid',
  'excludedFromRecurrent',
  'recurrency',
  'recurrencies',
  'entryunit',
]

// Reset rather than inherited. Times are blanked so the user has to choose them and
// cannot accidentally land on top of the original's slot; pinned is reset because
// inheriting it would silently pin two activities at once.
const RESET_FIELDS = {
  start: '',
  end: '',
  entrystart: '',
  entryend: null,
  // the deadline was set against the original's times; the copy follows its own entry end
  cancellationend: null,
  state: 'draft',
  ispublished: false,
  entryendProcessed: false,
  pinned: false,
}

export const buildActivityCopy = (activity) => {
  if (!activity) return null

  const source = { ...activity }
  DROPPED_FIELDS.forEach((field) => delete source[field])

  // Deep clone so the copy shares no nested object with the activity still on screen.
  // Dropping the server fields first keeps Firestore values out of the JSON round trip.
  const copy = JSON.parse(JSON.stringify(source))

  Object.assign(copy, RESET_FIELDS)

  // Strip question ids so the copy gets its own: createActivity runs
  // resolveActivityExtraInfo, which assigns an id to every question missing one.
  if (Array.isArray(copy.extrainfo)) {
    copy.extrainfo = copy.extrainfo.map(({ id, ...question }) => question)
  }

  // Only the Finnish name is editable in the UI, so that is the one that gets marked.
  copy.name = { fi: '', sv: '', en: '', ...(copy.name || {}) }
  if (copy.name.fi) copy.name.fi = copy.name.fi + COPY_NAME_SUFFIX

  return copy
}
